var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.583984 12.2474L7.00065 1.16406L13.4173 12.2474H0.583984ZM7.00065 10.4974C7.16593 10.4974 7.30447 10.4415 7.41628 10.3297C7.52808 10.2179 7.58398 10.0793 7.58398 9.91406C7.58398 9.74878 7.52808 9.61024 7.41628 9.49844C7.30447 9.38663 7.16593 9.33073 7.00065 9.33073C6.83537 9.33073 6.69683 9.38663 6.58503 9.49844C6.47322 9.61024 6.41732 9.74878 6.41732 9.91406C6.41732 10.0793 6.47322 10.2179 6.58503 10.3297C6.69683 10.4415 6.83537 10.4974 7.00065 10.4974ZM6.41732 8.74739H7.58398V5.83073H6.41732V8.74739Z",
    fill: "#9A6400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.ade63cf625f6b520471bd008ec6355a8.svg";
export { ForwardRef as ReactComponent };